import * as strings from './strings';

export default strings;
